// Radio group name for the delivery location picker, as rendered by
// snippets/cart-location-picker.liquid. Kept in one place so the two selectors
// built from it can never drift apart.
const DELIVERY_LOCATION_GROUP = 'available_dilevry_locations';
const DELIVERY_LOCATION_RADIOS = `input[name="${DELIVERY_LOCATION_GROUP}"]`;

// Back-button restores from the page cache with the old radio state intact.
// The source theme resets the group to the first radio here; this resets it to
// the radio the page rendered checked instead, which is the group holding the
// customer's saved location when they have one. The change event keeps the
// visible dropdown in step with the restored radio. It deliberately does not
// clear the selects, since TomSelect holds their display value.
window.addEventListener('pageshow', function(event) {
  if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
    const radios = Array.from(document.querySelectorAll(DELIVERY_LOCATION_RADIOS));
    const initialGroup = radios.find(function(radio) { return radio.defaultChecked; }) || radios[0];
    if (initialGroup) {
      initialGroup.checked = true;
      initialGroup.dispatchEvent(new Event('change'));
    }
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const checkoutButton = document.getElementById('checkout');
  const deliveryDateInput = document.getElementById('delivery_date');
  const giftMessageInput = document.getElementById('gift-message');
  const conciergeCommentInput = document.getElementById('concierge-comment');
  const errorContainer = document.getElementById('cart-field-errors');
  const picker = document.querySelector(`.${DELIVERY_LOCATION_GROUP}`);

  // Clear fields on page load to prevent storing previous order data
  if (deliveryDateInput) deliveryDateInput.value = '';
  if (giftMessageInput) giftMessageInput.value = '';
  if (conciergeCommentInput) conciergeCommentInput.value = '';
  const cartNoteField = document.getElementById('Cart-note');
  if (cartNoteField) cartNoteField.value = '';

  // Set minimum date to 3 days ahead
  if (deliveryDateInput) {
    const today = new Date();
    today.setDate(today.getDate() + 3);
    const minDate = today.toISOString().split('T')[0];
    deliveryDateInput.setAttribute('min', minDate);

    // iOS Safari doesn't enforce min attribute on native date pickers
    deliveryDateInput.addEventListener('change', function() {
      if (this.value && this.value < this.min) {
        showError('This date is not available. Please choose a date at least 3 days from today.');
        this.value = '';
      }
    });
  }

  function showError(message) {
    if (errorContainer) {
      errorContainer.textContent = message;
      errorContainer.style.display = 'block';
    }
  }

  function hideError() {
    if (errorContainer) {
      errorContainer.style.display = 'none';
      errorContainer.textContent = '';
    }
  }

  // Clear error on input
  if (deliveryDateInput) deliveryDateInput.addEventListener('input', hideError);
  if (giftMessageInput) giftMessageInput.addEventListener('input', hideError);
  if (conciergeCommentInput) conciergeCommentInput.addEventListener('input', hideError);

  /* ------------------------------------------------------------------ *
   * Delivery location picker — ported from the Magical Floral theme
   * (assets/cart-custom-form.js + assets/upsell-popup.js).
   *
   * Kept faithful to that implementation: the same select ids and the same
   * TomSelect options. The whole picker is absent unless the metaobjects have
   * entries, so every branch is guarded.
   * ------------------------------------------------------------------ */
  let getActiveSelection = null;

  if (picker) {
    const radioButtons = document.querySelectorAll(DELIVERY_LOCATION_RADIOS);

    // Note the double "s" in local_hotelss-locations — that is the id the
    // source theme renders, so the snippet and this list both carry it.
    const LOCATION_SELECT_IDS = [
      'disney_resorts-locations',
      'local_hotelss-locations',
      'other_locations-locations'
    ];

    // Skip cleanly if the library failed to load or a group is not rendered:
    // an uninitialised select still works as a plain <select>, whereas a throw
    // here would abort the rest of this block and leave checkout unvalidated.
    if (typeof TomSelect === 'function') {
      LOCATION_SELECT_IDS.forEach(function(id) {
        if (!document.getElementById(id)) return;
        new TomSelect(`#${id}`, {
          create: false,
          sortField: {
            field: 'text',
            direction: 'asc'
          }
        });
      });
    }

    function showSelectedDiv(selectedElementId) {
      document.querySelectorAll('.delivery-location-container').forEach(function(div) {
        if (div.id === selectedElementId) {
          div.style.display = 'block';
        } else {
          div.style.display = 'none';
        }
      });
    }

    // Initial setup based on checked radio
    radioButtons.forEach(function(radioButton) {
      if (radioButton.checked) {
        showSelectedDiv(radioButton.getAttribute('data-open-element'));
      }

      radioButton.addEventListener('change', function() {
        if (this.checked) {
          showSelectedDiv(this.getAttribute('data-open-element'));
          hideError();
        }
      });
    });

    // Resolve the container by the radio's own data-open-element (the same id
    // showSelectedDiv toggles) and fall back to the source theme's label →
    // container sibling walk. Returning null on a miss lets the checkout
    // handler show "Please select a delivery location" instead of throwing.
    getActiveSelection = function() {
      const checked = document.querySelector(`${DELIVERY_LOCATION_RADIOS}:checked`);
      if (!checked) return null;

      const container =
        document.getElementById(checked.getAttribute('data-open-element')) ||
        (checked.parentElement && checked.parentElement.nextElementSibling);
      const select = container && container.querySelector('select');
      if (!select) return null;

      const selectedOption = select.options[select.selectedIndex];

      return {
        groupLabel: checked.value,
        locationName: select.value,
        addressQuery: selectedOption ? selectedOption.getAttribute('data-address') : null,
      };
    };
  }

  // Validate on checkout button click
  if (checkoutButton) {
    checkoutButton.addEventListener('click', function(event) {
      const deliveryDate = deliveryDateInput ? deliveryDateInput.value.trim() : '';
      const giftMessage = giftMessageInput ? giftMessageInput.value.trim() : '';
      const conciergeComment = conciergeCommentInput ? conciergeCommentInput.value.trim() : '';
      const selection = getActiveSelection ? getActiveSelection() : null;

      function reject(message, field) {
        event.preventDefault();
        event.stopPropagation();
        showError(message);
        if (field) {
          field.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (typeof field.focus === 'function') field.focus();
        }
        return false;
      }

      if (picker && (!selection || !selection.locationName)) {
        return reject('Please select a delivery location', picker);
      }

      // Only Delivery Date and Gift Message are required
      if (!deliveryDate && !giftMessage) {
        return reject('Please fill in both Delivery Date and Gift Message', deliveryDateInput);
      } else if (!deliveryDate) {
        return reject('Please select a Delivery Date', deliveryDateInput);
      } else if (!giftMessage) {
        return reject('Please enter a Gift Message', giftMessageInput);
      }

      // Persist the location onto the order as cart attributes. Same two fields
      // and same split as the source: #selected-location holds the group,
      // #delivery_location_attr holds the location itself.
      if (selection) {
        const locationTypeField = document.getElementById('selected-location');
        const locationField = document.getElementById('delivery_location_attr');
        if (locationTypeField) locationTypeField.value = selection.groupLabel;
        if (locationField) locationField.value = selection.locationName;
      }

      // Write all data to Cart-note field so it appears in order notes
      if (cartNoteField) {
        let notesContent = `Delivery Date: ${deliveryDate} | Gift Message: ${giftMessage}`;
        if (selection) {
          notesContent = `Delivery Location: ${selection.groupLabel} — ${selection.locationName} | ` + notesContent;
        }
        if (conciergeComment) {
          notesContent += ` | Concierge Notes: ${conciergeComment}`;
        }
        cartNoteField.value = notesContent;
      }

      hideError();

      // Pre-fill the checkout shipping address by re-pointing the cart form and
      // submitting it, as the source theme does. The `checkout[...]` keys in the
      // query string are what make Shopify redirect to checkout rather than just
      // updating the cart, which is why this works without the submit button's
      // own name being posted.
      //
      // preventDefault first: this theme's checkout button is a real
      // type="submit" (the source's is type="button"), so without it the native
      // submit would race the programmatic one. Suppressing it also skips native
      // constraint validation, which is what lets the hidden `required` select
      // carrying form="cart" stay in the markup exactly as the source has it.
      if (selection && selection.addressQuery) {
        const cartForm = document.getElementById('cart');
        if (cartForm) {
          event.preventDefault();
          cartForm.action = `/cart${selection.addressQuery}`;
          cartForm.submit();
        }
      }
    });
  }
});
